module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_carro-dc82eae65e8b8fd7ab1d88cef2394a6b.png";